<template>
  <div>
    <v-list subheader class="mb-2 custom" v-if="!empty">
      <template v-for="(presentation, index) in presentations">
        <router-link
            :key="presentation.ended ? presentation.title : 'ongoing'"
            :to="{ name: route(presentation), params: { presentationId: presentation.presentationId }}"
            tag="div">
          <v-list-item :key="presentation.presentationId">
            <v-list-item-content>
              <v-list-item-title v-html="presentation.title"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="presentation.presented">
              <v-icon color="grey lighten-1">record_voice_over</v-icon>
            </v-list-item-action>
            <v-list-item-action v-if="!presentation.ended">
              <v-icon color="primary">play_circle_filled</v-icon>
            </v-list-item-action>
          </v-list-item>
        </router-link>
        <v-divider v-if="index < presentations.length - 1" :key="index"></v-divider>
      </template>
    </v-list>
    <div v-if="!recentPresentationsLoading && empty" class="empty-state text-uppercase caption">
      No presentations attended yet
    </div>
    <div class="text-center">
      <spinner v-if="recentPresentationsLoading"></spinner>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import spinner from './Spinner';

export default {
  name: 'eventlist',
  props: [
    'presentations'
  ],
  components: {
    spinner
  },
  computed: {
    empty() {
      return this.presentations && this.presentations.length === 0;
    },
    loading() {
      return typeof this.presentations === 'undefined';
    },
    ...mapGetters([
      'recentPresentationsLoading'
    ])
  },
  methods: {
    route(presentation) {
      if (presentation.presented) {
        return 'presented';
      } else if (!presentation.ended) {
        return 'attending';
      }
      return 'presentation';
    }
  }
};
</script>

<style scoped>
  .empty-state {
    padding: 32px 16px;
    color: #616161;
  }

  .v-list.custom {
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Eventlist.vue